import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '@/lib/utils'; // Assuming standard utils, or I'll implement a local one if needed. I'll use clsx/tailwind-merge pattern inline if utils not present, but usually standard. I'll assume standard props.
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#D4AF37] text-white hover:bg-[#B5952F] shadow-lg shadow-yellow-900/20',
    secondary: 'bg-[#2D5016] text-white hover:bg-[#1F3A0F] shadow-lg shadow-green-900/20',
    outline: 'border-2 border-[#2D5016] text-[#2D5016] hover:bg-[#2D5016]/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl uppercase tracking-wide'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className || ''}
      `} {...props} data-id="element-1285">
      {children}
    </motion.button>;
}